var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNightlife(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.296,23.715h-4.818c-0.53,0-1.039,0.211-1.414,0.586l-7.478,7.478H41.352c-0.914-4.049-4.534-7.084-8.855-7.084 c-5.009,0-9.084,4.075-9.084,9.084s4.075,9.084,9.084,9.084c1.481,0,2.927-0.371,4.221-1.05l8.964,10.513v15.96h-5.229 c-1.104,0-2,0.896-2,2s0.896,2,2,2h14.458c1.104,0,2-0.896,2-2s-0.896-2-2-2h-5.229V52.325l14.707-17.248 c0.507-0.594,0.621-1.428,0.295-2.136c-0.327-0.708-1.036-1.162-1.816-1.162h-4.627l4.063-4.063h3.99c1.104,0,2-0.896,2-2 S67.4,23.715,66.296,23.715z M32.498,38.862c-2.803,0-5.084-2.281-5.084-5.084s2.281-5.084,5.084-5.084 c2.093,0,3.893,1.273,4.671,3.084h-4.671c-0.78,0-1.489,0.454-1.816,1.162c-0.327,0.708-0.212,1.542,0.294,2.136l3.021,3.543 C33.513,38.769,33.011,38.862,32.498,38.862z M47.683,48.505l-9.067-10.634c0,0,0-0.001-0.001-0.001s0,0-0.001-0.001l-1.783-2.092 h21.704L47.683,48.505z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNightlife);
export default __webpack_public_path__ + "static/media/nightlife.ea4d3b6a10ac46b599751ac6bb7c48f0.svg";
export { ForwardRef as ReactComponent };